import { Injectable } from '@angular/core';
import { HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as Library from '../../core/library/index';

//
// Models
//
import { Response } from '../model/common/response';

//
// Services
//
import { RtiHttpBaseService } from './rti-HttpBaseService';

export type IMap<T> = (item: any) => T;

export interface IRtiHttpService {
  get<T>(endpoint: string, cb?: IMap<T>, param?: object);

  put<T>(endpoint: string, model: any, cb?: IMap<T>, param?: object);

  post<T>(endpoint: string, model: any, cb?: IMap<T>);

  patch<T>(endpoint: string, model: any, cb?: IMap<T>);

  delete<T>(endpoint: string, param?: object, cb?: IMap<T>);
}

@Injectable()
export class RtiHttpService implements IRtiHttpService {
  public get port() {
    return this.http.port;
  }

  public set port(value: string) {
    this.http.port = value;
  }

  public get server() {
    return this.http.server;
  }

  public set server(value: string) {
    this.http.server = value;
  }

  public get secure() {
    return this.http.secure;
  }

  public set secure(value: boolean) {
    this.http.secure = value;
  }

  public get prefix() {
    return this.http.prefix;
  }

  public set prefix(value: string) {
    this.http.prefix = value;
  }

  public get<T>(endpoint: string, cb?: IMap<T>, params?: object, headers?: HttpHeaders): Observable<Response<T>> {
    return this.http.get(endpoint, params, headers).pipe(
      map(resp => new Response<T>(resp, cb))
    );
  }

  public put<T>(endpoint: string, model: any, cb?: IMap<T>, params?: object): Observable<Response<T>> {
    return this.http.put(endpoint, model, params).pipe(
      map(resp => new Response<T>(resp, cb))
    );
  }

  public post<T>(endpoint: string, model: any, cb?: IMap<T>): Observable<Response<T>> {
    return this.http.post(endpoint, model).pipe(
      map(resp => new Response<T>(resp, cb))
    );
  }

  public patch<T>(endpoint: string, model: any, cb?: IMap<T>): Observable<Response<T>> {
    const isDefined = !Library.isUndefined(cb);
    return this.http.patch(endpoint, model).pipe(
      map(resp => new Response<T>(resp, cb))
    );
  }

  public delete<T>(endpoint: string, params?: object, cb?: IMap<T>): Observable<Response<T>> {
    return this.http.delete(endpoint, params).pipe(
      map(resp => new Response<T>(resp, cb))
    );
  }

  constructor(private http: RtiHttpBaseService) {
  }
}
